var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 96,
    viewBox: "0 0 90 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_620_2742)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.4392 95.9984C63.7543 95.9984 81.8443 77.9007 81.8443 55.576C81.8443 33.2514 63.7543 15.1537 41.4392 15.1537C19.1241 15.1537 1.03418 33.2514 1.03418 55.576C1.03418 77.9007 19.1241 95.9984 41.4392 95.9984Z",
    fill: "#F45170"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.23047 39.5989L45.5005 89.6907L78.5666 39.6194C76.4035 34.6041 73.2488 30.0779 69.2923 26.3127L44.7652 63.4552L20.3185 30.5971L8.23047 39.5989Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6168 86.5353L0.34668 36.4434L12.4347 27.4416L36.8814 60.2982L76.4725 0.346405L89.0438 8.65699L37.6168 86.5353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6168 86.8817C37.5626 86.8816 37.5092 86.8689 37.4608 86.8446C37.4124 86.8202 37.3704 86.785 37.3381 86.7415L0.0679758 36.6497C0.0135151 36.5761 -0.00961412 36.484 0.00366286 36.3934C0.0169398 36.3028 0.0655356 36.2212 0.138824 36.1663L12.2268 27.1645C12.3006 27.1099 12.393 27.0868 12.4839 27.1001C12.5747 27.1133 12.6566 27.162 12.7118 27.2353L36.8657 59.6967L76.1827 0.157456C76.2074 0.119373 76.2395 0.0866444 76.2771 0.0612176C76.3147 0.0357908 76.3571 0.0181846 76.4016 0.00944625C76.446 6.95046e-06 76.4918 -0.000537034 76.5364 0.00784131C76.581 0.0162197 76.6235 0.0333537 76.6614 0.0582576L89.2344 8.36884C89.2723 8.39395 89.3049 8.4263 89.3304 8.46403C89.3558 8.50176 89.3736 8.54414 89.3827 8.58874C89.3917 8.63334 89.3919 8.67928 89.3832 8.72396C89.3745 8.76863 89.3571 8.81115 89.332 8.84909L37.9049 86.7258C37.8747 86.7727 37.8336 86.8115 37.785 86.839C37.7365 86.8664 37.682 86.8816 37.6262 86.8832L37.6168 86.8817ZM0.830063 36.5143L37.5994 85.9322L88.5636 8.75461L76.5685 0.825073L37.1696 60.4903C37.1391 60.5369 37.0979 60.5756 37.0494 60.603C37.0009 60.6304 36.9466 60.6457 36.8909 60.6477C36.8353 60.649 36.7803 60.6371 36.7302 60.613C36.6801 60.5889 36.6365 60.5533 36.6027 60.5092L12.3622 27.9266L0.830063 36.5143Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_620_2742"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.39,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.6f4726bc22301e58c4cae05feb37c465.svg";
export { ForwardRef as ReactComponent };